import { BiHomeAlt } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineShowChart } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { SlWrench } from "react-icons/sl";
import { BsFileEarmarkCheck } from "react-icons/bs";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import fetchClient from "../../axios/fetch";

const SidebarMain = ({ content, setCurrentContents }) => {
    const auth = useSelector((state) => state.auth);
    const Navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const [isApprover, setIsApprover] = useState(false);

    useEffect(() => {
        if (auth?.user?.id) {
            fetchClient()
                .get("api/approval/approvers")
                .then((res) => {
                    const approvers = res.data.data;
                    if (!approvers || approvers.length === 0) {
                        setIsApprover(false);
                    } else {
                        const found = approvers.find(
                            (value) => value.userId === auth.user.id && value.isApprover === true
                        );
                        setIsApprover(!!found);
                    }
                })
                .catch(() => setIsApprover(false));
        } else {
            setIsApprover(false);
        }
    }, [auth?.user?.id]);

    if (!auth.isAuthenticated || !auth.user || !auth.user.userRole) {
        return null;
    }

    const isAdmin = auth.user.userRole === "admin";
    const isPH = auth.user.country === "ph";
    const openSettings = () => setCurrentContents("settings");

    const menus = [
        {
            key: "home",
            show: true,
            onClick: () => Navigate("/home"),
            active: location.pathname === "/home" || location.pathname === "/",
            icon: <BiHomeAlt className="icons" size="1.2em" />,
            label: t("home")
        },
        {
            key: "admin",
            show: (isAdmin && (isApprover || isPH)) || (isAdmin && (isApprover || !isPH)),
            onClick: () => Navigate("/admin"),
            active: location.pathname === "/admin",
            icon: <IoSettingsOutline className="icons" size="1.2em" />,
            label: t("administrator")
        },
        {
            key: "report",
            show: (isAdmin && (isApprover || isPH)) || (isAdmin && (isApprover || !isPH)),
            onClick: () => Navigate("/report"),
            active: location.pathname === "/report",
            icon: <MdOutlineShowChart className="icons" size="1.2em" />,
            label: t("reports")
        },
        {
            key: "approvals",
            show: (isAdmin && isApprover && isPH) || (!isAdmin && isApprover && isPH) || (isAdmin && !isApprover && isPH),
            onClick: () => Navigate("/approvals"),
            active: location.pathname === "/approvals",
            icon: <BsFileEarmarkCheck className="icons" size="1.2em" />,
            label: t("meeting_room_approval")
        },
        {
            key: "settings",
            show: true,
            onClick: openSettings,
            active: content === "settings",
            icon: <SlWrench className="icons" size="1.2em" />,
            label: t("settings")
        }
    ];

    let filteredMenus = [];
    if ((isAdmin && isApprover && isPH) || (isAdmin && !isApprover && isPH)) {
        // Admin, aprobador y PH: acceso a todos los menús
        filteredMenus = menus;
    } else if (isAdmin && !isPH) {
        // Admin, aprobador y NO PH: home, admin, report
        filteredMenus = menus.filter(m =>
            m.key === "home" || m.key === "admin" || m.key === "report" || m.key === "settings"
        );
    } else if (!isAdmin && isApprover && isPH) {
        // NO admin, aprobador y PH: home, approvals, settings
        filteredMenus = menus.filter(m =>
            m.key === "home" || m.key === "approvals" || m.key === "settings"
        );

    } else {
        // Otros casos: home y settings
        filteredMenus = menus.filter(m =>
            m.key === "home" || m.key === "settings"
        );
    }

    return (
        <div className="sidebar-top d-flex flex-column gap-2">
            {filteredMenus.filter(m => m.show).map(menu => (
                <Nav.Link
                    key={menu.key}
                    className={`sidebar-links${menu.key === "settings" ? " settings" : ""}`}
                    onClick={menu.onClick}
                    active={menu.active}
                >
                    {menu.icon}
                    {menu.label}
                </Nav.Link>
            ))}
        </div>
    );
};

export default SidebarMain;